function extractBlockId (link) {
  if (typeof link === 'object') {
    return link[Object.keys(link)[0]]
  }

  return link
}

export default function actions (platform) {
  const actions = {
    nodeSetPageBranchBlock (payload, runLinkSet = false) {
      const { blocks, branches, layout, links, nodeFields, plugins } = payload.newRenderData

      if (blocks) {
        for (const blockId in blocks) {
          platform.store.update(store => {
            store.render.blocks[blockId] = blocks[blockId]

            return store
          })
        }
      }

      if (layout && layout.block && layout.block.nodes) {
        platform.store.update(store => {
          store.render.branches[layout.block.id] = layout.block

          return store
        })
      }

      if (links) {
        for (const nodeId in links) {
          platform.store.update(store => {
            store.render.links[nodeId] = links[nodeId]
            if (runLinkSet) {
              store.editor.actions.push({
                name: 'LINK_SET',
                meta: {
                  nodeId,
                  blockId: extractBlockId(links[nodeId]),
                },
              })
            }

            return store
          })
        }
      }

      if (branches) {
        for (const branchId in branches) {
          platform.store.update(store => {
            store.render.branches[branchId] = branches[branchId]

            return store
          })
        }
      }

      if (nodeFields) {
        for (const nodeFieldId in nodeFields) {
          platform.store.update(store => {
            store.render.nodeFields[nodeFieldId] = nodeFields[nodeFieldId]

            return store
          })
        }
      }

      if (plugins) {
        for (const pluginId in plugins) {
          platform.store.update(store => {
            store.render.plugins[pluginId] = plugins[pluginId]

            return store
          })
        }
      }

      platform.store.update(store => {
        store.render.links[payload.nodeId] = payload.blockId
        if (runLinkSet) {
          store.editor.actions.push({
            name: 'LINK_SET',
            meta: {
              nodeId: payload.nodeId,
              blockId: extractBlockId(payload.blockId),
            },
          })
        }
        return store
      })
    },
  }

  return actions
}
